import React, {Component} from 'react'
import {Button, Message, Segment,} from 'semantic-ui-react'
import PropTypes from 'prop-types'


export class Contract extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            contractGenerated: props.contractGenerated,
        };
    }

    generateContract(e) {
        this.setState({'loading': true, contractGenerated: false}, () => this.props.generateContract(e));

    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (this.state.contractGenerated === false && nextProps.contractGenerated === true) {
            this.setState({loading: false, contractGenerated: true});
        } else {
            this.setState({contractGenerated: nextProps.contractGenerated});
        }
    }

    render() {
        const {loading} = this.state;
        const {contract, contractError} = this.props;
        const {contractGenerated} = this.state;
        const href = 'data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,' + encodeURIComponent(contract);
        return (
            <Segment>
                <Segment className='theEnd generate'>
                    <h2>Congratulations</h2>
                    <p>You have reached the end of the data collection form.</p>
                    <p>You can now generate the contract by clicking on the button below.</p>
                    <Button default id='generate-contract' loading={loading}
                            onClick={(e) => this.generateContract(e)}
                            style={{margin: '20px 0'}}>Generate Contract</Button>
                </Segment>
                {contractGenerated && !contractError && <Segment className='theEnd success'>
                    <h2>Contract was generated successfully</h2>
                    <a style={{margin: '20px 0'}} className="button ui positive" href={href}
                       download='contract.docx'>Download</a>
                </Segment>
                }
                {contractGenerated && contractError && <Segment className='theEnd error'>
                    <Message negative>
                        <Message.Header>We're sorry. Something went wrong.</Message.Header>
                        <p>An error occurred during the contract generation.</p>
                        <p style={{fontFamily: 'monospace,monospace', fontSize: '1em'}}>{contractError}</p>
                    </Message>
                </Segment>
                }
            </Segment>
        )
    }
}

Contract.propTypes = {
    contractGenerated: PropTypes.bool.isRequired,
    contract: PropTypes.string.isRequired,
    generateContract: PropTypes.func.isRequired
};

